import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import MobileStepper from "@material-ui/core/MobileStepper";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import SwipeableViews from "react-swipeable-views";
import { IOffer } from "./ICart";
import { CartOffer } from "./CartOffer";

interface IParams {
    arrowStep: number;
    carouselItemCount: number;
    offerList: IOffer[];
    handleBack(): void;
    handleNext(): void;
    handleOfferClick(selectedOffer: IOffer): void;
    handleStepChange(step: number): void;
}
export const CartOfferListMobile = (props: IParams) => {
    const {
        arrowStep,
        carouselItemCount,
        handleStepChange,
        offerList,
        handleNext,
        handleBack,
        handleOfferClick,
    } = props;

    return (
        <Grid alignItems="center" container justify="center">
            <Grid item xs={12}>
                <SwipeableViews axis="x" enableMouseEvents index={arrowStep} onChangeIndex={handleStepChange}>
                    {offerList.map((offer, index) => (
                        /* eslint-disable-next-line react/no-array-index-key */
                        <Grid item key={index} xs={12}>
                            <CartOffer handleOfferClick={handleOfferClick} offer={offer} />
                        </Grid>
                    ))}
                </SwipeableViews>
            </Grid>
            {offerList.length > 1 && (
                <Grid item xs={6}>
                    <MobileStepper
                        activeStep={arrowStep}
                        backButton={
                            <Button
                                className="xtest_arrow"
                                color="primary"
                                disabled={arrowStep === 0}
                                size="small"
                                onClick={handleBack}
                            >
                                <KeyboardArrowLeft fontSize="large" />
                            </Button>
                        }
                        nextButton={
                            <Button
                                className="xtest_arrow"
                                color="primary"
                                disabled={arrowStep + carouselItemCount >= offerList.length}
                                size="small"
                                onClick={handleNext}
                            >
                                <KeyboardArrowRight fontSize="large" />
                            </Button>
                        }
                        position="static"
                        steps={offerList.length}
                        variant="dots"
                    />
                </Grid>
            )}
        </Grid>
    );
};
